import React, {useState, useCallback, useEffect} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation, useLazyQuery } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup, ButtonContainer } from 'app/src/elements/buttons';
import { View, Pressable, Text } from 'react-native';
import { UPDATE_EXPENSE_LINE, SELECTS } from './queries';
import { formatAssetNameForSelect } from '../../../utils/formatAssetName';
import Autocomplete from '../../Autocomplete';
import { useParams } from 'react-router-dom';
import {
  ExpenseLineRow,
  ExpenseLineCellNoBorder,
  ExpenseLineCellExpandedNoBorder,
  ExpenseLineFunctionsCellNoBorder
} from '.';
import { LinkSpace } from '../../../elements';

const EditExpenseLine = ({expenseLine, setClickedExpenseLine,
  updateExpenseLinesList
}) => {
  const [submitting, setSubmitting] = useState();
  const [assets, setAssets] = useState();
  const { assetId } = useParams();
  const [selectOptions, setSelectOptions] = useState([]);
  const [updateExpenseLine] = useMutation(UPDATE_EXPENSE_LINE, {
    onCompleted: (response) => {
      updateExpenseLinesList(response.updateExpenseLine.expenseLine, false)
      setClickedExpenseLine('');
    }
  });

  const [ loadSelectOptions, { loading: loading, data: data } ] =
    useLazyQuery(SELECTS, {
      onCompleted: () => setSelectOptions(data?.saleAssetOptions)
    }
  );

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    updateExpenseLine({ variables: input });
  });

  const { control, handleSubmit, register, getValues, setValue, formState: { errors } } = useForm({
    defaultValues: {
      id: expenseLine.id,
      assetId: expenseLine.asset?.id || '',
      // saleAssetId: expenseLine.saleAsset?.id || '',
      amount: expenseLine.amount || 0,
      description: expenseLine.description || ''
    }
  });

  useEffect(() => {
    loadSelectOptions({variables: {assetId: getValues('assetId') || assetId}})
  }, [])

  return (
    <ExpenseLineRow>
      { !assetId &&
        <ExpenseLineCellExpandedNoBorder>
          <Autocomplete
            label={'Asset'}
            placeHolder={''}
            resource={'Asset'}
            options={assets}
            setValue={setValue}
            name='assetId'
            defaultValue={expenseLine.asset}
          />
        </ExpenseLineCellExpandedNoBorder>
      }
      {/* <ExpenseLineCellExpandedNoBorder>
        {getValues('assetId') ?
          <Input.Picker
            label="Sale:"
            name="saleAssetId"
            control={control}
            errors={errors}
            options={
              selectOptions?.map(option => {
                return {value: option.id, label: option.lotNumber}
              })
            }
          /> :
          <Autocomplete
            label={'Sale'}
            placeHolder={''}
            resource={'SaleAsset'}
            setValue={setValue}
            name='saleAssetId'
            {...register("saleAssetId", {
              required: "Required",
            })}
          />
        }
      </ExpenseLineCellExpandedNoBorder> */}
      <ExpenseLineCellNoBorder>
        <Input.Currency
          label="Amount:"
          name="amount"
          control={control}
          errors={errors}
          id="amount"
          {...register("amount", {
            required: "Amount is required",
            validate: {
              matchPattern: (v) =>
                /\d{1,10}(\.{1}\d{1,2}){0,1}?$/.test(v) ||
                "Please use number only without commas",
            },
          })}
        />
      </ExpenseLineCellNoBorder>
      <ExpenseLineCellNoBorder>
        <Input.Text
          label="Description:"
          name="description"
          control={control}
          errors={errors}
        />
      </ExpenseLineCellNoBorder>
      <ExpenseLineFunctionsCellNoBorder>
        <Pressable
          onPress={handleSubmit(onSubmit)}
        >
          <Text>update</Text>
        </Pressable>
        <LinkSpace />
        <Pressable
          onPress={() => setClickedExpenseLine('')}
        >
          <Text>cancel</Text>
        </Pressable>
      </ExpenseLineFunctionsCellNoBorder>
    </ExpenseLineRow>
  )
}

export default EditExpenseLine;
